// src/pages/Login.jsx

import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { serverURL } from '../config/const';
import { useAuth } from '../context/AuthContext'; // Using the context as seen in your Register logic

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { login } = useAuth(); // Assuming useAuth provides a login method to update global state

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(null);

    try {
      // 1. Post to the login endpoint
      const response = await axios.post(`${serverURL}/api/login`, {
        email,
        password
      });

      // 2. Axios puts the response body in .data
      const data = response.data;

      // 3. Update AuthContext with the user data returned from your API
      // Adjust this based on your API response structure (e.g., data.user or just data)
      login(data.user || data);

      console.log('Login successful!');
      
      // 4. Redirect to home or dashboard after successful login
      navigate("/"); 

    } catch (err) {
      // Handle login failure using the axios error structure
      const errorMessage = err.response?.data?.message || 'Login failed';
      setError(errorMessage);
    }
  };

  return (
    <div className="flex justify-center items-center h-screen">
      <form onSubmit={handleSubmit} className="bg-white p-8 rounded shadow-md w-full max-w-sm">
        <h2 className="text-2xl mb-4 text-brandBlue font-bold">Sign In to Drive Dobias</h2>
        
        {error && <p className="text-red-500 mb-4">{error}</p>}
        
        <div className="mb-4">
          <label className="block mb-1 text-gray-700">Email:</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full border p-2 rounded"
            placeholder="email@example.com"
            required
          />
        </div>

        <div className="mb-6">
          <label className="block mb-1 text-gray-700">Password:</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full border p-2 rounded"
            placeholder="••••••••"
            required
          />
        </div>

        <button 
          type="submit" 
          className="w-full bg-blue-600 text-white p-2 rounded font-semibold hover:bg-blue-700 transition-colors"
        >
          Login
        </button>

        <p className="mt-4 text-sm text-center">
          Don't have an account?{' '}
          <Link to="/register" className="text-blue-600 hover:underline">
            Register here
          </Link>
        </p>
      </form>
    </div>
  );
}
